var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Initiate eSign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eSign-/-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "office-sign-document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.164,13.293 C10.0320661,12.3961507 11.4570079,12.3553239 12.375,13.201 C13.2200217,14.1188571 13.1792038,15.5430471 12.283,16.411 C11.402,17.294 7.531,18.043 7.531,18.043 C7.531,18.043 8.283,14.174 9.164,13.293 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.73,5.568 L16.369,1.929 C16.6446828,1.65328908 17.0186058,1.49839393 17.4085,1.49839393 C17.7983942,1.49839393 18.1723172,1.65328908 18.448,1.929 L19.488,2.969",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17,11.286 L19.488,2.969 C20.3505464,2.11075522 21.7444536,2.11075522 22.607,2.969 L22.607,2.969 C23.4641513,3.83199747 23.4641513,5.22500253 22.607,6.088 L14.289,14.405 L11.17,11.286 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.369,
    y1: 6.088,
    x2: 19.488,
    y2: 9.207,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.22,13.5 C21.22,17.541 21.645,19.825 19.462,22.008 L18.33,23.139 C18.2591481,23.2089464 18.1635614,23.248 18.064,23.248 L1.125,23.248 C0.973429173,23.248 0.836842121,23.1565025 0.778856512,23.0164618 C0.720870902,22.876421 0.752889849,22.7152434 0.86,22.608 L1.46,22.008 C3.725,19.743 3.22,18.294 3.22,6.234 C3.22,3.086 5.568,1.4 6.22,0.748 L10.668,0.748",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsign);
export default __webpack_public_path__ + "static/media/esign.5c55874b45db125d38d24ba092daa8ff.svg";
export { ForwardRef as ReactComponent };